import erc20 from 'abis/erc20.json';
import { formatUnits } from 'ethers/lib/utils';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { Chain } from '@thirdweb-dev/chains';
import { getContract } from '@thirdweb-dev/react';
import { useSupportedChain } from '@app/hooks/other/useSupportedChain';

async function fetcher(
  tokenContractAddress: string,
  address: string,
  network: Chain | undefined
) {
  if (!network || !tokenContractAddress || !address) {
    return null;
  }

  const contract = await getContract({
    address: tokenContractAddress,
    network,
    contractTypeOrAbi: erc20
  });

  // @ts-ignore
  const balance = await contract.call('balanceOf', [address]);
  // @ts-ignore
  const decimals = await contract.call('decimals');

  return formatUnits(balance, decimals);
}

export function useTokenBalance(tokenContractAddress: string, address: string) {
  const chain = useSupportedChain();

  const { data } = useQuery(
    [QueryKeys.GET_TOKEN_BALANCE, tokenContractAddress, address, !!chain],
    () => fetcher(tokenContractAddress, address, chain),
    {
      enabled: Boolean(tokenContractAddress && address && chain)
    }
  );

  return {
    balance: data
  };
}
